import { Component } from 'react';
import { I18nContext } from 'context/i18n.context';
import HtmlStandard from 'components/HtmlStandard';
import Layout from 'components/Layout';

export default class Error extends Component {
	static contextType = I18nContext;

	constructor(props) {
		super(props);
	}

	static getInitialProps({ res, err }) {
		const statusCode = res ? res.statusCode : err ? err.statusCode : null;
		return { statusCode };
	}

	renderError(statusCode) {
		return (
			<div className="html-page">
				<h1>
					{`Error ${statusCode}`}<br/>{this.context.t('fileNotFound')}
				</h1>
				<div
					dangerouslySetInnerHTML={{
						__html: this.context.t('notFoundInfo')
					}}
				/>
			</div>
		);
	}

	render() {
		const metatags = { ...this.props.metatags, title: `${this.props.statusCode} - ${this.context.t('fileNotFound')}` };

		return (
			<HtmlStandard metatags={metatags} context={this.props.context}>
				<Layout>
					<article id="main-content">
						<div className="article-content">
							{this.props.statusCode
								? this.renderError(this.props.statusCode)
								: 'An error occurred on the client'}
						</div>
					</article>
				</Layout>
			</HtmlStandard>
		);
	}
}
